// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__dnCZk","modalForm":"UpgradeEpcsModal_modalForm__2IhN0","modalFooter":"UpgradeEpcsModal_modalFooter__2ktYr"};